import styled from "styled-components";
import { Modal } from "components/Modal";
import { Button } from "components/Button/index";

export const StrategyControlModalContainer = styled(Modal)`
  .modal-content {
    padding: 0px;

    .modal-body {
      padding: 0px;
      margin-top: 0px;

      .heading {
        display: flex;
        align-items: center;
        padding: 14px 15px;
        background-color: ${({ theme }) => theme.modal.bg.secondary};
        border-top-left-radius: 7px;
        border-top-right-radius: 7px;

        h2 {
          width: 100%;
          text-align: center;
          color: ${({ theme }) => theme.card.font.tertiary};
          font-size: 20px;
          font-weight: 500;
          margin-bottom: 0px;
        }
      }

      .body-content {
        padding: 5px 20px 30px;

        .table-container {
          min-height: 416px;
        }
      }
    }
  }
  .body-heading {
    color: ${({ theme }) => theme.card.font.tertiary};
    text-align: center;
    font-size: 20px;
    font-weight: 500;
    margin-top: 5px;
  }

  .modal-dialog {
    max-width: 750px;
  }

  .table-container {
    max-height: 416px;
    overflow-y: scroll;

    .table-wrapper {
      margin-top: 12px;

      .ineligible-row {
        background-color: ${({ theme }) => theme.table.bg.primary};
      }

      tfoot {
        tr {
          border-bottom: none;
        }
      }

      .table-cell {
        font-weight: 500;
        line-height: 140%;
        color: ${({ theme }) => theme.table.font.primary};
      }

      .non-sticky-header {
        position: relative;
      }

      .strategy-table-header {
        .dropdown-toggle::after {
          display: none;
        }
      }

      .active-row {
        background: transparent;
        border-radius: 8px;
      }

      .name-icon-wrapper {
        display: flex;
        align-items: center;
        gap: 10px;

        .icon-broker {
          height: 35px;
          border-radius: 50%;
        }
      }

      .eligibility-space {
        /* margin-top: -18px; */
      }

      .broker-sub-text {
        display: block;
        color: ${({ theme }) => theme.card.font.quaternary};
        font-size: 12px;
        line-height: 135%;
      }

      .eligibility {
        font-size: 12px;
        color: ${({ theme }) => theme.global.color.bodyColor};
        font-weight: 400;
        font-style: italic;
      }
    }
  }

  .broker-btn-space {
    display: flex;
    justify-content: center;

    button {
      width: 100%;
      height: 40px;
      font-size: 14px;
      font-weight: 500;
    }
  }

  .header-action-wrapper {
    position: relative;
  }

  .btn-action {
    width: 155px;
    .btn-group {
      width: 150px;
    }

    button {
      border-radius: ${({ theme }) => theme.constants.BORDER_RADIUS_25};
      margin-right: 1px;
    }

    .dropdown-toggle-split {
      border-radius: ${({ theme }) => theme.constants.BORDER_RADIUS_8};
      height: 35px;
      padding: 6px;
      margin-top: 0.7px;
      background: ${({ theme }) => theme.button.bg.primary};
      border-color: ${({ theme }) => theme.button.bg.primary};
    }

    .dropdown-btn {
      width: 168px;
      padding: 0 15px;
      display: flex;
      align-items: center;
      gap: 8px;
    }
  }

  .text-right {
    text-align: right;
  }

  .form-check-input {
    background-color: transparent;
    border: 1px solid #838383;
    box-shadow: none;
    border-radius: 3px;
    cursor: pointer;
  }

  .selection-wrapper {
    .dropdown button {
      padding-bottom: 0;
    }

    button {
      display: flex;
      background: transparent;
      border: 0;
      align-items: center;

      &:hover {
        background-color: transparent;
      }
    }
    input {
      height: 20px;
      width: 20px;
    }
  }

  .active-row {
    background: #4a506b;
  }

  .dropdown-menu::after {
    display: none;
  }

  .pause-strategy-modal,
  .stop-strategy-modal {
    .modal-body .logo-img .img {
      width: 130px;
      height: 130px;
    }
    .modal-content {
      max-width: 392px;
    }
    .heading {
      padding: 0 12px;
    }
  }
  .strategy-control-actions {
    .dropdown-menu {
      margin-top: -14px;
      margin-right: -6px;

      &.show {
        background: ${({ theme }) => theme.button.bg.primary};
        margin-top: 16px;
      }

      .dropdown-item {
        font-size: 12px;
        color: #ffffff;
        text-align: start;

        &:hover {
          background-color: ${({ theme }) => theme.button.bg.primary};
          color: ${({ theme }) => theme.button.font.primary};
        }

        img {
          margin-right: 5px;
        }

        &.disabled {
          color: ${({ theme }) => theme.global.extraInfo.font.color};
        }
      }
    }
  }

  .mobile-view {
    padding-top: 20px;
    max-height: 500px;
    overflow: auto;

    .no-data-text {
      color: #3c587c;
      text-align: center;
      border: none;
      padding: 20px 0px;
      margin-bottom: 12px;
    }
  }

  @media screen and (max-width: 768px) and (min-width: 576px) {
    .modal-dialog {
      max-width: 80%;
    }
  }

  @media (max-width: 768px) {
    .body-heading {
      font-weight: 700;
      font-size: 18px;
      max-width: 90%;
    }

    .modal-body {
      padding: 10px;

      .details-wrapper .status {
        border-radius: 25px;
      }

      .btn-action .dropdown-toggle-split {
        text-align: center;

        &.start-list-options-menu {
          top: -20px !important;
          right: 4px !important;
          border-radius: 50% !important;
        }
      }
    }

    .broker-btn-space button {
      height: 40px;
    }
  }
`;

export const StrategyControlBtn = styled(Button)`
  height: 39px;
  background-color: ${({ theme }) => theme.global.color.quinary};
  font-weight: 500;
  margin-top: 0.5rem !important;
  text-transform: none;
`;
